@import (reference) 'ui-components/components/button/button-text.module.less';

// necessary to beat specificity of underlying component styles
.ship-date {
  .button-text();
}
